import * as React from 'react';

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  indeterminate?: boolean;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, indeterminate, ...props }, ref) => {
    const checkboxRef = React.useRef<HTMLInputElement>(null);
    const combinedRef = ref || checkboxRef;

    React.useEffect(() => {
      if (typeof combinedRef === 'object' && combinedRef?.current) {
        combinedRef.current.indeterminate = indeterminate ?? false;
      }
    }, [combinedRef, indeterminate]);

    return (
      <input
        type="checkbox"
        ref={combinedRef}
        className={`
          h-4 w-4 rounded border-gray-300 dark:border-gray-600
          text-purple-600 focus:ring-purple-500 focus:ring-offset-0
          bg-white dark:bg-gray-800
          cursor-pointer
          ${className || ''}
        `}
        {...props}
      />
    );
  }
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
